<template>
  <div class="swiper-top">
    <div class="clear">
      <img
        src="https://picbed.qunarzz.com/d8e239da4d6cdf62f5b6d8d0fa3de4fd.jpg"
        alt=""
      />
    </div>
    <videoComp></videoComp>
    <img
      src="https://picbed.qunarzz.com/87585942501788c7d0f5aab8855c4333.png"
      alt=""
    />
    <div class="swiper-fluid">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="(item, index) in imgList"
            :key="index"
            class="swiper-slide"
          >
            <div class="img-box2">
              <a v-maidian="'note_' + index" v-if="item.link" :href="item.link">
                <img :src="item.img" alt="" />
              </a>
              <img v-else :src="item.img" alt="" />
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>
<script>
import videoComp from "./video.vue";
export default {
  components: {
    videoComp,
  },
  data() {
    return {
      imgList: [
        {
          img:
            "https://picbed.qunarzz.com/4a274cc494c41d35882da0b92225c45d.jpg",
          link: "https://touch.travel.qunar.com/youji/7666321",
        },
        {
          img:
            "https://picbed.qunarzz.com/f6d380199734e1267bd0545a267493ba.jpg",
          link: "http://travel.qunar.com/travelbook/note/7666320",
        },
        {
          img:
            "https://picbed.qunarzz.com/885bbebd27b685c384aa55aa0a5a667f.jpg",
          link: "http://travel.qunar.com/travelbook/note/7666394",
        },
        {
          img:
            "https://picbed.qunarzz.com/2bb043d51a09f3119e62c9866c8cd036.jpg",
          link: "http://travel.qunar.com/travelbook/note/7667096",
        },

        {
          img:
            "https://picbed.qunarzz.com/7270a4617993994ef95ee4fe3eebb837.jpg",
          link: "http://travel.qunar.com/travelbook/note/7662309",
        },
        {
          img:
            "https://picbed.qunarzz.com/51e94e8a4fa0752378fb964f9f964d43.jpg",
          link: "http://travel.qunar.com/travelbook/note/7667131",
        },
        {
          img:
            "https://picbed.qunarzz.com/26f5f7ae4c45bc1b7305667981d7eeb6.jpg",
          link: "http://travel.qunar.com/travelbook/note/7667034",
        },
        {
          img:
            "https://picbed.qunarzz.com/4d66bf33a8215e17c5a6a5522bb1d585.jpg",
          link: "http://travel.qunar.com/travelbook/note/7667158",
        },
      ],
      swiperList: {
        swiper1: null,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.swiperList.swiper1 = new Swiper(".swiper-top .swiper-container", {
        loop: true, // 循环模式选项
        autoplay: true,
        autoplay: {
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
      });
    });
  },
  methods: {
    goNext(swiperName) {
      let swiper = this.swiperList[swiperName];
      swiper.slideNext();
    },
    goPrev(swiperName) {
      let swiper = this.swiperList[swiperName];
      swiper.slidePrev();
    },
  },
};
</script>
<style lang='less' scoped='true'>
.sub-tit {
  width: 150px;
  margin-left: auto;
  margin-right: auto;
}
.swiper {
  &-fluid {
    position: relative;
    top: -15px;
  }
  &-top {
    position: relative;
    height: 581px;
  }
  &-cont {
    float: left;
    width: calc(100% - 164px);
    margin-left: 10px;
    text-align: left;
    font-size: 12px;
    color: #fff;
    font-weight: bold;
  }
  &-des {
    color: #f3eae5;
    font-size: 11px;
    font-weight: normal;
    margin-top: 4px;
  }
  &-container {
    width: calc(100% - 16px);
    margin-left: auto;
    margin-right: auto;
    .light {
      float: left;
      &-box {
        .btn {
          padding: 2px 12px;
          border: 1px solid #feb926;
          color: #feb926;
          float: left;
          font-size: 11px;
          border-radius: 5px;
          margin-top: 8px;
          line-height: 1.414;
          margin-left: 14px;
        }
      }
      margin-top: 5px;
      img {
        width: 24px;
      }
    }
  }
  &-next,
  &-prev {
    background: url(https://picbed.qunarzz.com/80d357495b4ae2af14e7abc355f0597a.png)
      no-repeat;
    background-size: 100% auto;
    background-position: center center;
    position: absolute;
    top: 50%;
    z-index: 20;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    width: 16px;
    height: 38px;
  }
  &-next {
    right: 12px;
  }
  &-prev {
    left: 12px;
    background-image: url(https://picbed.qunarzz.com/2bb4217666b9f683ba8aa0de070da123.png);
  }
}
.img-box2 {
  position: relative;
  height: 180px;
  overflow-y: hidden;
  img {
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
</style>